module.exports = __webpack_public_path__ + "images/柏纳长图_04-5.jpg?v=79e57469";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_04-5.jpg
 ** module id = 143
 ** module chunks = 1 2
 **/